<div class="relative">
  <button
    class="border-0 justify-start items-center flex p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
    [ngClass]="{ 'bg-[#17233D]': menuState }"
  >
    <div class="text-white text-sm font-normal leading-tight mr-1.5">Ещё</div>
    <div class="flex items-center justify-center">
      <svg
        width="8"
        height="4"
        viewBox="0 0 8 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.73831 0.204157C7.71247 0.143494 7.66902 0.0917348 7.61342 0.055404C7.55782 0.0190731 7.49257 -0.000204223 7.42588 1.63161e-06H0.670657C0.603975 -0.000204223 0.538723 0.0190731 0.483124 0.055404C0.427525 0.0917348 0.384067 0.143494 0.358228 0.204157C0.333894 0.265724 0.327721 0.332832 0.340422 0.397717C0.353124 0.462602 0.384182 0.522612 0.430002 0.570804L3.80762 3.90396C3.87218 3.96556 3.95847 4 4.04827 4C4.13808 4 4.22437 3.96556 4.28893 3.90396L7.66654 0.570804C7.71236 0.522612 7.74342 0.462602 7.75612 0.397717C7.76882 0.332832 7.76265 0.265724 7.73831 0.204157Z"
          fill="white"
        />
      </svg>
    </div>
  </button>
  <div
    class="absolute pt-2.5 z-50 transition-all"
    [ngClass]="{
      'opacity-0 -translate-y-[5px] pointer-events-none': !menuState,
      'opacity-100 translate-y-0 pointer-events-auto': menuState,
    }"
  >
    <div
      class="bg-white rounded-lg shadow flex-col justify-start items-start flex"
    >
      <div
        class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
      >
        <a
          href="https://rentag.ru/karera"
          target="_blank"
          class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"
          rel="nofollow"
          >Карьера</a
        >
      </div>
      <div
        class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
      >
        <a
          href="https://rentag.ru/faq"
          rel="nofollow"
          target="_blank"
          class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"
          >База знаний</a
        >
      </div>
      <div
        class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
      >
        <a
          href="https://rentag.ru/documents"
          rel="nofollow"
          target="_blank"
          class="text-center text-slate-950 text-sm font-normal leading-tight whitespace-nowrap"
          >Юридические документы</a
        >
      </div>
    </div>
  </div>
</div>
